'use client';
import { useState, useEffect } from 'react';
import { createClient } from '@/lib/supabase/client';

interface BrandLogos {
  logoIconUrl: string;
  logoWordmarkUrl: string;
  loading: boolean;
}

let cachedLogos: { logoIconUrl: string; logoWordmarkUrl: string } | null = null;

export function useBrandLogos(): BrandLogos {
  const [logos, setLogos] = useState<{ logoIconUrl: string; logoWordmarkUrl: string }>({
    logoIconUrl: cachedLogos?.logoIconUrl ?? '',
    logoWordmarkUrl: cachedLogos?.logoWordmarkUrl ?? '',
  });
  const [loading, setLoading] = useState(!cachedLogos);

  useEffect(() => {
    if (cachedLogos) {
      setLogos(cachedLogos);
      setLoading(false);
      return;
    }
    const supabase = createClient();
    supabase
      .from('platform_settings')
      .select('key, value')
      .in('key', ['logo_icon_url', 'logo_wordmark_url'])
      .then(({ data }) => {
        const map: Record<string, string> = {};
        data?.forEach((row) => { map[row.key] = row.value; });
        const result = {
          logoIconUrl: map['logo_icon_url'] ?? '',
          logoWordmarkUrl: map['logo_wordmark_url'] ?? '',
        };
        cachedLogos = result;
        setLogos(result);
        setLoading(false);
      });
  }, []);

  return { ...logos, loading };
}
